import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-200 ${
        scrolled ? 'bg-white border-b border-[#E2E8F0]' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 h-32 flex items-center justify-between">
        <a href="/" className="flex items-center -ml-2">
          <img
            src="https://public.readdy.ai/ai/img_res/f8500d79-1d2e-424d-9304-47c35dba9100.png"
            alt="Foraged Fuel Logo"
            className="object-contain"
            style={{ width: '120px', height: '120px' }}
          />
        </a>

        <div className="hidden md:flex items-center gap-8">
          <a
            href="#specs"
            className="text-sm font-semibold text-[#475569] hover:text-[#0F172A] transition-colors whitespace-nowrap cursor-pointer"
          >
            Technical Specs
          </a>
          <a
            href="#benefits"
            className="text-sm font-semibold text-[#475569] hover:text-[#0F172A] transition-colors whitespace-nowrap cursor-pointer"
          >
            Formulator Benefits
          </a>
          <a
            href="#supply"
            className="text-sm font-semibold text-[#475569] hover:text-[#0F172A] transition-colors whitespace-nowrap cursor-pointer"
          >
            Supply Chain
          </a>
          <a
            href="tel:9548655411"
            className="bg-[#0F172A] text-white text-sm font-semibold px-4 py-2 rounded-md hover:bg-[#1e293b] transition-colors whitespace-nowrap cursor-pointer"
          >
            Contact
          </a>
        </div>

        {/* Mobile */}
        <a
          href="tel:9548655411"
          className="md:hidden bg-[#0F172A] text-white text-sm font-semibold px-4 py-2 rounded-md whitespace-nowrap cursor-pointer"
        >
          Contact
        </a>
      </div>
    </nav>
  );
}
